import React from 'react';
import 'whatwg-fetch';

const apiBarCode = '/api/stock/barcode/';

const oriState = {
  text: '',
};

export default class AppStockModalOut extends React.Component {
  constructor(props) {
    super(props);
    this.state = oriState;

    this.handleInputChange = this.handleInputChange.bind(this);
    this.reset = this.reset.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.close = this.close.bind(this);
  }

  reset() {
    this.state = oriState;
    this.setState(oriState);
    this.componentDidMount();
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  componentDidMount() {}

  render() {
    if (this.props.isOpen === false) return null;

    return (
      <div className='modal myModal myModal-stock'>
        <div className='modal-dialog modal-md'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h4 className='modal-title'>
                {this.props.modalPurpose === 'withdraw'
                  ? 'Retirer'
                  : this.props.modalPurpose === 'remove'
                  ? 'Supprimer'
                  : 'Remettre'}{' '}
                Produit(s)
              </h4>
              <button onClick={this.close} type='button' className='close' data-dismiss='modal' aria-label='Close'>
                <span aria-hidden='true'>&times;</span>
              </button>
            </div>
            <form>
              <div className='modal-body'>
                <p>
                  Veuillez rentrez les code-barres des produits à{' '}
                  {this.props.modalPurpose === 'withdraw'
                    ? 'retirer du stock'
                    : this.props.modalPurpose === 'remove'
                    ? 'supprimer du stock'
                    : 'remettre en stock'}
                </p>
                <div className='form-group'>
                  <textarea
                    name='text'
                    value={this.state.text}
                    onChange={this.handleInputChange}
                    type='text'
                    className='form-control'
                    placeholder='Vous pouvez entrer un ou plusieurs code-barres séparés par des retours à la ligne'
                  />
                </div>
              </div>

              <div className='modal-actions'>
                <button onClick={this.close} type='button' className='btn-link modal-action' data-dismiss='modal'>
                  Annuler
                </button>
                <button
                  onClick={this.handleSubmit}
                  type='button'
                  className='btn-link modal-action'
                  data-dismiss='modal'
                >
                  <strong>Valider</strong>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }

  close() {
    this.reset();
    if (this.props.onClose) {
      this.props.onClose();
    }
  }

  handleSubmit() {
    if (this.state.text && this.state.text.trim() !== '') {
      let entered = this.state.text;

      // Check integrity
      let regEx = new RegExp(/^[0-9 /\n/]+$/); // only digits & new lines
      if (regEx.test(entered)) {
        entered = entered.trim().split('\n');
        let products = [];
        for (let i = 0; i < entered.length; i++) {
          let item = {
            id: entered[i],
          };
          products.push(item);
        }

        let json = {
          products: products,
        };
        this.props.onPost(this.props.modalPurpose, json);
        this.close();
      } else {
        // invalid input
        this.props.openToast(false, 'Invalide. Veuillez rentrer uniquement des chiffres et des retours à la ligne');
      }
    } else {
      this.props.openToast(false, 'Veuillez renseigner des code-barres.');
    }
  }
}
